<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc">Contents</h2>
<p class="first"><a href="#/Text/SECT02#toc">Introduction</a></p>
<p class="first"><a href="#/Text/SECT03#toc">How to Get the Most Out of This Book</a></p>
<p class="first"><a href="#/Text/SECT04#toc">1 The Peculiar Community</a></p>
<p><a href="#/Text/SECT04#heading_id_8"><em>Soul Training: Two-by-Four</em></a></p>
<p class="first"><span href="#/Text/SECT05#toc" title="Link target outside of Sample">2 The Hopeful Community</span></p>
<p><span href="#/Text/SECT05#heading_id_8" title="Link target outside of Sample"><em>Soul Training: Sharing Your Faith</em></span></p>
<p class="first"><span href="#/Text/SECT06#toc" title="Link target outside of Sample">3 The Serving Community</span></p>
<p><span href="#/Text/SECT06#heading_id_8" title="Link target outside of Sample"><em>Soul Training:</em> <em>Treasuring Our Treasures</em></span></p>
<p class="first"><span href="#/Text/SECT07#toc" title="Link target outside of Sample">4 The Christ-Centered Community</span></p>
<p><span href="#/Text/SECT07#heading_id_8" title="Link target outside of Sample"><em>Soul Training:</em> <em>Loving Those We Disagree With</em></span></p>
<p class="first"><span href="#/Text/SECT08#toc" title="Link target outside of Sample">5 The Reconciling Community</span></p>
<p><span href="#/Text/SECT08#heading_id_8" title="Link target outside of Sample"><em>Soul Training:</em> <em>Experiencing Reconciliation</em></span></p>
<p class="first"><span href="#/Text/SECT09#toc" title="Link target outside of Sample">6 The Encouraging Community</span></p>
<p><span href="#/Text/SECT09#heading_id_8" title="Link target outside of Sample"><em>Soul Training:</em> <em>Finding an Accountability Friend</em></span></p>
<p class="first"><span href="#/Text/SECT10#toc" title="Link target outside of Sample">7 The Generous Community</span></p>
<p><span href="#/Text/SECT10#heading_id_8" title="Link target outside of Sample"><em>Soul Training:</em> <em>Stewardship of Resources</em></span></p>
<p class="first"><span href="#/Text/SECT11#toc" title="Link target outside of Sample">8 The Worshiping Community</span></p>
<p><span href="#/Text/SECT11#heading_id_8" title="Link target outside of Sample"><em>Soul Training:</em> <em>Worship</em></span></p>
<p class="first"><span href="#/Text/SECT12#toc" title="Link target outside of Sample">9 Writing a Soul-Training Plan</span></p>
<p class="first"><span href="#/Text/SECT14#toc" title="Link target outside of Sample">Appendix: Small Group Discussion Guide</span></p>
<p class="first"><span href="#/Text/eNotes#toc" title="Link target outside of Sample">Notes</span></p>
<p class="first"><span href="#/Text/SECT16#toc" title="Link target outside of Sample">Acknowledgments</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?e95b2076